
function getNiceTicks(this: any, value: string, index: number, values: string[]): string | null {
    const max = values.length - 1;
    if (max <= 9) return (this as any).chart.data.ticks[index];
    switch (index) {
        case 0:
        case Math.floor(max / 4):
        case Math.floor(max / 2):
        case Math.floor(3 * max / 4):
        case max:
            return (this as any).chart.data.ticks[index];
        case Math.floor(max / 8):
        case Math.floor(3 * max / 8):
        case Math.floor(5 * max / 8):
        case Math.floor(7 * max / 8):
            return '–';
    }
    return null;
}

function getFullTicks(this: any, value: string, index: number, values: string[]): string | null {
    return (this as any).chart.data.ticks[index];
}

export default class ChartOptions {

    public static LineChartOptions(graphSettings:GraphSettings, onRowSelection:any): any {
        return {
            onClick: (evt:any, element:any) => { onRowSelection(element) },
            responsive: true,
            plugins: {
                datalabels: {
                    display: graphSettings.showDataLabels ? true : false,
                    align: 'top',
                    anchor: 'end',
                    color: 'black'
                }
            },
            maintainAspectRatio: true,

            animation: {
                duration: 1000,
                easing: 'easeInOutQuad',
            },
            legend: {
                display: graphSettings.showLegend,
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        tickMarkLength: 0,
                        color: '#e4e4e5',
                        zeroLineColor: '#e4e4e5',
                    },
                    ticks: {
                        autoSkip: false,
                        padding: 10,
                        maxRotation: graphSettings.rotateXAxisLabel ? 80 : 0,
                        minRotation: graphSettings.rotateXAxisLabel ? 80 : 0,
                        callback: getNiceTicks
                    },
                }],
                yAxes: [{
                    gridLines: {
                        drawBorder: false,
                        tickMarkLength: 0,
                        color: '#e4e4e5',
                        zeroLineColor: '#e4e4e5',
                    },
                    ticks: {
                        maxTicksLimit: 5,
                        autoSkip: false,
                        padding: 10,
                    },
                }]
            }
        };
    }

    public static StackedBarChartOptions(graphSettings:GraphSettings, onRowSelection:any): any {
        return {
            onClick: (evt:any, element:any) => { onRowSelection(element) },
            responsive: true,
            plugins: {
                datalabels: {
                    display: graphSettings.showDataLabels ? true : false,
                    align: 'top',
                    anchor: 'end',
                    color: 'black'
                }
            },
            maintainAspectRatio: true,
            backgroundColor: '#ffffff',
            animation: {
                duration: 1000,
                easing: 'easeInOutQuad',
            },
            legend: {
                display: graphSettings.showLegend,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            scales: {
                xAxes: [{
                    stacked: true,
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        tickMarkLength: 0,
                        color: '#e4e4e5',
                        zeroLineColor: '#e4e4e5',
                    },
                    ticks: {
                        min: 0,
                        autoSkip: false,
                        padding: 10,
                        maxRotation: graphSettings.rotateXAxisLabel ? 80 : 0,
                        minRotation: graphSettings.rotateXAxisLabel ? 80 : 0,
                        callback: graphSettings.rotateXAxisLabel ? getFullTicks: getNiceTicks
                    },
                }],
                yAxes: [{
                    stacked: true,
                    gridLines: {
                        drawBorder: false,
                        tickMarkLength: 0,
                        color: '#e4e4e5',
                        zeroLineColor: '#e4e4e5',
                    },
                    ticks: {
                        beginAtZero: true,
                        min: 0,
                        autoSkip: false,
                        padding: 10,
                    },
                }]
            }
        }
    }

    public static DoughnutChartOptions(graphSettings:GraphSettings): any {
        return {
            responsive: true,
            plugins: {
                datalabels: {
                    display: graphSettings.showDataLabels ? true : false,
                    align: 'top',
                    anchor: 'end',
                    color: 'black'
                }
            },
            maintainAspectRatio: true,
            backgroundColor: '#ffffff',
            cutoutPercentage: 85,
            animation: {
                duration: 1000,
                easing: 'easeInOutQuad',
            },
            legend: {
                display: graphSettings.showLegend,
            },
        }
    }

    public static BarChartOptions(): any {
        return {
        }
    }
}